import Config from "../constant/Config";
import { fetchJsonIfOk } from "./ServiceUtils";

export const getRound = async (roundId) => {
  return await fetchJsonIfOk(`${Config.apiurl}/round?roundId=${roundId}`);
}
